import { render, staticRenderFns } from "./TheCodeAdvisorTable.vue?vue&type=template&id=11463a6a&scoped=true"
import script from "./TheCodeAdvisorTable.vue?vue&type=script&lang=js"
export * from "./TheCodeAdvisorTable.vue?vue&type=script&lang=js"
import style0 from "./TheCodeAdvisorTable.vue?vue&type=style&index=0&id=11463a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11463a6a",
  null
  
)

export default component.exports